import script from "./FixmeList.vue?vue&type=script&setup=true&lang=js"
export * from "./FixmeList.vue?vue&type=script&setup=true&lang=js"

import "./FixmeList.vue?vue&type=style&index=0&id=8da1cc2c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8da1cc2c"]])

export default __exports__